@if (fleet) {
<div class="section-title">{{fleet.fleet_name}}</div>
}

@if (fleet) {
<div class="mb-3">
	<a [href]="'/dash/fleet/' + fleet.fleet_id">Open in Foresight <i class="icon-link-ext"></i></a>
</div>
}

@if (fleet) {
<div class="panel expander">
	<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Fleet settings</div>
	<div class="content">
		<form>
			<div class="mb-3 row">
				<label class="col-md-4">Time display offset (hrs):</label>
				<div class="col-md-8">
					<input type="number" [(ngModel)]="fleet.time_offset_hours" name="time_offset_hours">
				</div>
			</div>
			<div class="mb-3 row">
				<label class="col-md-4">Hidden from dashboard:</label>
				<div class="col-md-8">
					<input [(ngModel)]="fleet.hidden" type="checkbox" name="hidden">
				</div>
			</div>
			<div class="mb-3">
				<app-action-button submit [action]="UpdateFleet" [context]="this" processing="Updating..." complete="Fleet updated">Update Fleet</app-action-button>
			</div>
		</form>
	</div>
</div>
}
<div class="panel expander" [class.collapsed]="fleet">
	<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Add new asset/OBCU to this fleet</div>
	<div class="content">
		<form>
			<div class="mb-3 row">
				<label class="col-md-4">Configuration</label>
				<div class="col-md-8">
					<select [(ngModel)]="newAsset.asset_type_id" name="asset_type_id" class="form-control">
						@for (config of orgConfigs; track config) {
						<option [ngValue]="config.asset_type_id">{{config.asset_type_name}}
						</option>
						}
					</select>
				</div>
			</div>
			<div class="mb-3 row">
				<label class="col-md-4">Asset name</label>
				<div class="col-md-8">
					<input [(ngModel)]="newAsset.asset_name" name="asset_name" type="text" class="form-control">
				</div>
			</div>
			<div class="mb-3 row">
				<label class="col-md-4">Server ID</label>
				<div class="col-md-6">
					<input [(ngModel)]="newAsset.obcu_serial_number" name="obcu_serial_number" type="text" class="form-control">
				</div>
				<div class="col-md-2">
					<app-action-button [action]="FreshenSerial" [context]="this" processing="..." title="Fetch next serial">◀</app-action-button>
				</div>
			</div>
			<div class="mb-3 row">
				<div class="col-md-8 offset-md-4">
					<app-action-button submit [action]="AddAsset" [context]="this" processing="Adding..." complete="Asset added" btnClass="wide">Add Asset</app-action-button>
				</div>
			</div>
		</form>
		@if (newAssetAuth) {
		<div>
			<p class="message-good">The asset has been created, with the communication key below. Copy this key and save it to the OBCU config. You will not be able to come back and
				look it up again.</p>
			<div class="mb-3 row">
				<label class="col-md-4">Asset communication key</label>
				<div class="col-md-8">{{newAssetAuth}}</div>
			</div>
		</div>
		}
	</div>
</div>
@if (fleet) {
<div class="panel expander collapsed">
	<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Delete this fleet</div>
	<div class="content">
		<p>Note that any assets currently assigned to this fleet will be moved into the "No fleet assigned" group</p>
		<div class="mb-3 row">
			<div class="col-md-8 offset-md-4">
				<app-action-button [action]="DeleteFleet" [context]="this" processing="Deleting..." complete="Fleet deleted"
					confirm="Are you sure? Assets will be moved to 'No fleet assigned'" btnClass="red wide">Delete Fleet</app-action-button>
			</div>
		</div>
	</div>
</div>
}